<!-- navItem „Storno“ — Stornodatum und eingefrorener Haftungsbetrag. -->
<div class="cp-provision-contract-agent-cancellation">

    <cp-provision-object-data
            objectType="cp.ProvisionContractAgent"
            [objectId]="provisionContractAgentId"
            widgetAlias="cp.contractAgent.cancellation"
            widgetTitle="Storno"
            [fields]="fields"
            [columns]="columns"
            emptyText="Kein Provisionssatz ausgewählt.">
    </cp-provision-object-data>

</div>
